import TextInput from 'components/common/inputs/TextInput';
import { useContext, useState } from 'react';
import { t } from 'services/i18n.service';
import { useAppDispatch } from 'store/hooks';
import { updateCustomRoutine } from 'store/reducer/setting/slice';
import { CUSTOM_ROUTINE_FEATURE } from 'constants/general';
import { CustomRoutineContext } from '.';

const CustomRoutineName = () => {
  const dispatch = useAppDispatch();
  const customRoutine = useContext(CustomRoutineContext);
  const [name, setName] = useState(customRoutine?.name ?? '');

  return (
    <label
      htmlFor={`custom_routine_input-${customRoutine?.position}`}
      className='w-full flex flex-col gap-0.5'
      data-testid='custom-routine-name-label'>
      <span className='~text-xs/sm text-black dark:text-secondary-dark-900'>
        {t('name')}
      </span>
      <TextInput
        id={`custom_routine_input-${customRoutine?.position}`}
        value={name}
        onChange={({ target: { value } }) => {
          setName(value);
          customRoutine &&
            dispatch(
              updateCustomRoutine({
                feature: CUSTOM_ROUTINE_FEATURE.NAME,
                position: customRoutine?.position,
                value
              })
            );
        }}
        name={`custom_routine_input-${customRoutine?.position}`}
        placeholder={t('settings_page.enter_routine_name')}
      />
    </label>
  );
};

export default CustomRoutineName;
